import React from 'react';

const TableSkeleton = ({ rows = 5, columns = 4 }) => {
    return (
        <div className="table-skeleton-container" style={{ padding: '20px' }}>
            <div className="skeleton-header" style={{
                height: '40px',
                background: 'linear-gradient(90deg, var(--color-gray-10) 25%, var(--color-gray-30) 50%, var(--color-gray-10) 75%)',
                backgroundSize: '200% 100%',
                animation: 'skeleton-loading 1.5s infinite',
                borderRadius: '8px',
                marginBottom: '20px'
            }} />
            {[...Array(rows)].map((_, i) => (
                <div key={i} className="skeleton-row" style={{
                    display: 'flex',
                    gap: '15px',
                    marginBottom: '15px'
                }}>
                    {[...Array(columns)].map((_, j) => (
                        <div key={j} className="skeleton-cell" style={{
                            flex: 1,
                            height: '50px',
                            background: 'linear-gradient(90deg, var(--color-gray-10) 25%, var(--color-gray-30) 50%, var(--color-gray-10) 75%)',
                            backgroundSize: '200% 100%',
                            animation: 'skeleton-loading 1.5s infinite',
                            borderRadius: '8px',
                            animationDelay: `${(i + j) * 0.1}s`
                        }} />
                    ))}
                </div>
            ))}
            <style>
                {`
                @keyframes skeleton-loading {
                    0% { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }
                `}
            </style>
        </div>
    );
};

export default TableSkeleton;
